import { PRICE_SOURCES_MANAGE_PERMISSION } from '@/core/config/auth-permissions.config';
import type { DrawerRouteDef } from '@/core/drawer-route.util';

/** The `data.drawer` id of the source create drawer — `/price-sources/new`. */
export const PRICE_SOURCE_DRAWER_CREATE = 'create';

/** The `data.drawer` id of the read-only audit trail — `/price-sources/:id/history`. */
export const PRICE_SOURCE_DRAWER_HISTORY = 'history';

/** The `data.drawer` id of the rename drawer — `/price-sources/:id/rename`. */
export const PRICE_SOURCE_DRAWER_RENAME = 'rename';

/**
 * The Price Sources screen's deep-link drawer inventory (DAG node (d)).
 *
 * The screen has NO edit form (rename is the only mutation of an existing
 * source), so no plain `/:id` record is generated — the URL vocabulary is
 * exactly what the screen can show: create, the audit trail and rename
 * (`DESIGN-WUIAM-135` user decisions, 2026-10-27).
 *
 * History is VIEWER-REACHABLE (the row action carries no permission — a
 * view-only session still gets it), so its guard tuple is `null` and it is
 * attached without a discard veto (nothing to lose in a read-only sheet).
 * Create and rename are manage-only and form-bearing: the same
 * `PRICE_SOURCES_MANAGE_PERMISSION` constant the row menu gates on, plus the
 * dirty veto. Delete (in-memory confirmation) has NO URL.
 */
export const PRICE_SOURCES_DRAWER_DEFS: readonly DrawerRouteDef[] = [
  {
    path: 'new',
    drawer: PRICE_SOURCE_DRAWER_CREATE,
    permission: PRICE_SOURCES_MANAGE_PERMISSION,
    veto: true,
  },
  {
    path: ':id/history',
    drawer: PRICE_SOURCE_DRAWER_HISTORY,
    permission: null,
    veto: false,
  },
  {
    path: ':id/rename',
    drawer: PRICE_SOURCE_DRAWER_RENAME,
    permission: PRICE_SOURCES_MANAGE_PERMISSION,
    veto: true,
  },
];
